<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <span class="breadcrumbs__title">Convenios</span>
        <v-icon>mdi-chevron-right</v-icon>
        <span>Gestión de convenios</span>
        <v-divider class="mt-2"></v-divider>
        <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
        <v-row class="mt-10">
          <v-col cols="12">
            <v-form ref="form" v-model="valid" lazy-validation width="100%">
              <v-card class="mx-auto">
                <div class="d-flex justify-space-between align-center">
                  <v-card-title>Identificación del Convenio</v-card-title>
                </div>
                <v-divider></v-divider>
                <div class="separator"></div>
                <v-divider class="mb-4 pb-1"></v-divider>
                <v-card-text class="text--primary pt-0">
                  <!-- START OF FORM -->
                  <v-row class="dense_layout">
                    <v-col cols="3">
                      <v-select
                        :disabled="newDisable"
                        v-model="convenio.type"
                        :items="['Contrato', 'Convenio']"
                        item-text="state"
                        outlined
                        label="Naturaleza"
                        :rules="askForValidation ? emptyField : []"
                      ></v-select>
                    </v-col>
                    <v-col cols="3">
                      <v-select
                        :disabled="newDisable"
                        v-model="convenio.typeNecesidad"
                        :items="[
                          'Plan anual de RSE',
                          'Plan anual de Márqueting',
                        ]"
                        item-text="state"
                        outlined
                        label="Necesidad de Contrato o Convenio"
                        :rules="askForValidation ? emptyField : []"
                      ></v-select>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete
                        :disabled="newDisable"
                        v-model="convenio.ambito"
                        :items="ambitoOptions"
                        outlined
                        label="Ambito"
                        item-text="name"
                        item-value="name"
                        :rules="askForValidation ? emptyField : []"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-select
                        :disabled="newDisable"
                        v-model="convenio.typeAction"
                        :items="['Acción planificada', 'Acción emergente']"
                        item-text="state"
                        outlined
                        label="Tipo de acción"
                        :rules="askForValidation ? emptyField : []"
                      ></v-select>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete
                        :disabled="newDisable"
                        v-model="convenio.convenioingCompany"
                        :items="convenioingCompanies"
                        outlined
                        label="Empresa Contratante"
                        item-text="name"
                        item-value="name"
                        :rules="askForValidation ? emptyField : []"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-menu
                        :disabled="newDisable"
                        v-model="pd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="newDisable"
                            v-model="convenio.proposalDate"
                            label="Fecha solicitud"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :rules="askForValidation ? emptyField : []"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="convenio.proposalDate"
                          @input="pd = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="convenio.descOrShortName"
                        outlined
                        :disabled="newDisable"
                        :readonly="newDisable"
                        auto-grow
                        label="Objeto del convenio"
                        :rules="limitCharRules"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                        :disabled="newDisable"
                        :readonly="newDisable"
                        v-model="convenio.description"
                        outlined
                        label="Descripción del convenio"
                        rows="4"
                        :rules="askForValidation ? emptyField : []"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="3"
                      ><CurrencyInput
                        :disabled="newDisable"
                        v-model="convenio.amount"
                        label="Importe"
                        outlined
                        :rules="askForValidation ? emptyField : []"
                    /></v-col>
                    <v-col cols="3">
                      <v-menu
                        :disabled="newDisable"
                        v-model="pc"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="newDisable"
                            v-model="convenio.startingDate"
                            label="Fecha inicio"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :rules="askForValidation ? emptyField : []"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="convenio.startingDate"
                          @input="pc = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker>
                      </v-menu>
                      <v-menu
                        :disabled="newDisable"
                        v-model="pb"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="newDisable"
                            v-model="convenio.endingDate"
                            label="Fecha Fin"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :rules="askForValidation ? emptyField : []"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="convenio.endingDate"
                          @input="pb = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="convenio.ambito === 'RSE'"
                    class="dense_layout mt-8"
                  >
                    <v-col cols="12" class="mb-3">
                      <h3>Evaluación del proyecto RSE</h3>
                    </v-col>
                    <v-col cols="6">
                      <v-row class="ml-0" v-for="rowIndex in 4" :key="rowIndex">
                        <v-radio-group
                          v-model="selectedOptions[rowIndex - 1]"
                          row
                        >
                          <v-radio
                            v-for="columnIndex in 5"
                            :key="columnIndex"
                            :label="'Option ' + columnIndex"
                            :value="columnIndex"
                          ></v-radio>
                        </v-radio-group>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="convenio.amount >= 5000 && convenio.ambito === 'RSE'"
                  >
                    <v-col cols="12" class="mb-3">
                      <h3>Informe detective</h3>
                    </v-col>
                    <v-col cols="3">
                      <v-radio-group
                        v-model="convenio.informeDetective"
                        class="mt-0"
                      >
                        <v-radio :value="true">
                          <template v-slot:label>
                            <div>Informe favorable</div>
                          </template>
                        </v-radio>
                        <v-radio :value="false">
                          <template v-slot:label>
                            <div>Informe NO favorable</div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col v-if="convenio.informeDetective" cols="3">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <v-file-input
                            :rules="emptyField"
                            v-model="informeDetectiveFile"
                            label="Informe detective"
                            required
                          ></v-file-input>
                        </v-col>
                        <v-col cols="2" class="mt-3">
                          <v-icon
                            large
                            v-if="convenio.formalinformeDetectiveFileFile"
                            @click="
                              downloadFile(
                                convenio.informeDetectiveFile,
                                convenio.informeDetectiveFileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                      <v-textarea
                        :disabled="newDisable"
                        :readonly="newDisable"
                        v-model="convenio.justification"
                        outlined
                        name="input-7-4"
                        label="Justificación"
                        rows="4"
                        :rules="askForValidation ? emptyField : []"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider class="mb-2"></v-divider>
                <div
                  v-if="
                    this.convenio.state > 0 || this.convenio.validation.date
                  "
                >
                  <!-- Soy validador, accedo a validar pero aún no se ha validado -->
                  <v-card-title class="text-h6 custom__title primary--text py-0"
                    >Validación
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-col cols="6">
                        <v-row class="dense_layout">
                          <v-col cols="6">
                            <v-radio-group
                              :disabled="
                                this.convenio.state !== 1 || !isValidator
                              "
                              v-model="convenio.validation.validation"
                              class="mt-0"
                            >
                              <v-radio :value="true">
                                <template v-slot:label>
                                  <div>Aprobado</div>
                                </template>
                              </v-radio>
                              <v-radio :value="false">
                                <template v-slot:label>
                                  <div>No Aprobado</div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col cols="6">
                            <v-menu
                              v-model="fp"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :disabled="
                                    convenio.state !== 1 || !isValidator
                                  "
                                  v-model="convenio.validation.date"
                                  label="Fecha Resolución"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  :rules="emptyField"
                                  clearable
                                  required
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                :disabled="convenio.state !== 1 || !isValidator"
                                v-model="convenio.validation.date"
                                @input="fp = false"
                                locale="es-ES"
                                :first-day-of-week="1"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="!convenio.validation.validation"
                          >
                            <v-textarea
                              :disabled="
                                this.convenio.state !== 1 || !isValidator
                              "
                              v-model="convenio.validation.description"
                              outlined
                              label="Motivo Disconformidad"
                              required
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
                <div
                  v-if="
                    this.convenio.state > 1 && this.convenio.validation.date
                  "
                >
                  <!-- Soy validador, accedo a validar pero aún no se ha validado -->
                  <v-card-title class="text-h6 custom__title primary--text py-0"
                    >Formalización Acuerdo
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-col cols="6">
                        <v-row class="dense_layout">
                          <v-col cols="12">
                            <v-row no-gutters>
                              <v-col cols="10">
                                <v-file-input
                                  :disabled="
                                    this.convenio.state === 4 && isPromotor
                                  "
                                  :rules="emptyField"
                                  v-model="formalFile"
                                  label="Adjuntar Documento"
                                  required
                                ></v-file-input>
                              </v-col>
                              <v-col cols="2" class="mt-3">
                                <v-icon
                                  large
                                  v-if="convenio.formalFile"
                                  @click="
                                    downloadFile(
                                      convenio.formalFile,
                                      convenio.formalFileName
                                    )
                                  "
                                >
                                  mdi-file-download-outline
                                </v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
                <v-card-actions class="pl-4">
                  <div class="d-flex flex-column align-baseline">
                    <v-checkbox
                      v-if="this.convenio.state === 0"
                      v-model="askForValidation"
                      :disabled="newDisable"
                      id="uno"
                      label="Solicitar validación"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                    <v-btn
                      v-if="this.convenio.state < 4"
                      id="dos"
                      color="primary"
                      @click="submit(0)"
                      :disabled="convenio.state === 1 ? !isValidator : !valid"
                      class="white--text mt-1 mb-5"
                      ><v-icon left> mdi-content-save-outline</v-icon
                      >Guardar</v-btn
                    >
                  </div>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CurrencyInput from "@/components/CurrencyInput.vue";
import fieldValidation from "@/utils/fieldValidation.js";
import formatters from "@/utils/formatters.js";
import services from "@/services/services";
import { mapActions, mapGetters } from "vuex";
import Snackbar from "@/components/Snackbar";
import router from "@/router";
export default {
  name: "Convenios",
  props: ["id"],
  components: { Snackbar, CurrencyInput },
  data() {
    return {
      selectedOptions: [null, null, null, null], // Initialize with null values for each row
      questions: ["Question 1", "Question 2", "Question 3", "Question 4"],
      rolesGV: [1],
      convenioID: null,
      pd: false,
      pc: false,
      pb: false,
      fp: false,
      askForValidation: false,
      ambitoOptions: ["RSE", "MKT / RRHH", "Otros"],
      formalFile: null,
      informeDetectiveFile: null,
      convenio: {
        id: "",
        promoter: "",
        descOrShortName: "",
        creationDate: "",
        fileName: "",
        description: "",
        type: "",
        ambito: "",
        informeDetective: false,
        typeNecesidad: "",
        typeAction: "",
        proposalDate: "",
        convenioingCompany: "",
        startingDate: "",
        endingDate: "",
        justification: "",
        amount: "",
        state: 0,
        formalFile: null,
        formalFileName: null,
        informeDetectiveFile: null,
        informeDetectiveFileName: null,
        validation: {
          validator: "",
          date: null,
          validation: false,
          description: "",
        },
      },
      currentEmail: "",
      textError: null,
      isSnackbar: false,
      editEmail: true,
      editPassword: true,
      selectedFile: null,
      isSelecting: false,
      siglas: [
        { id: 1, sigla: "DG", name: "Direcció General" },
        { id: 2, sigla: "DAF", name: "Direcció d'Administració i Finances" },
        { id: 3, sigla: "DPE", name: "Direcció de Projectes Especials" },
        { id: 4, sigla: "DEX", name: "Direcció d'Explotació" },
        { id: 5, sigla: "DCO", name: "Direcció de Comunicació i RSE" },
        {
          id: 6,
          sigla: "DST",
          name: "Direcció de Sistemes Integrats de Gestió i TIC / CCO",
        },
        { id: 7, sigla: "CC", name: "CC" },
      ],
      siglaUser: "",
      user: {
        picture: null,
        name: "",
        surname: "",
        email: "",
        password: "",
        sigla: "",
        address: "",
        post: "",
        creationDate: formatters.formatDate(new Date()),
        status: true,
      },
      userID: null,
      newPassword: "",
      pictureToPreview: null,
      valid: false,
      emptyField: [(v) => fieldValidation.emptyField(v)],
      limitCharRules: [(v) => (v && v.length <= 40) || "Máximo 40 caracteres"],
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "getUserData",
      "getUsers",
      "getCompany",
      "getConvenios",
    ]),
    isPromotor() {
      return (
        this.getUserData &&
        this.getUserData.role.includes(3) &&
        this.getUserData.id === this.convenio.promoter
      );
    },
    isValidator() {
      return (
        this.getUserData &&
        this.getUserData.id === this.convenio.validation.validator
      );
    },
    convenioingCompanies() {
      return this.getCompany;
    },
    disableNotPtomoter() {
      return this.getUserData && this.getUserData.superAdmin;
    },
    newDisable() {
      if (this.convenio.state === 0) return false;
      else if (this.convenio.state > 1) return true;
      else if (this.getUserData && this.getUserData.superAdmin) {
        return false;
      } else return true;
    },
  },
  methods: {
    ...mapActions(["setActionsLoader", "getDBConvenios"]),
    calculateTotal(selectedOptions) {
      return selectedOptions.reduce((acc, val) => acc + val, 0);
    },
    async save() {
      let that = this;
      if (!this.convenio.creationDate) {
        this.convenio.creationDate = new Date().toLocaleString();
      }
      return new Promise((resolve, reject) => {
        services
          .saveData("convenios", this.convenio)
          .then((data) => {
            this.setActionsLoader(false);
            that.convenioID = data.id;
            this.convenio.id = data.id;
            resolve(true);
            this.textError = null;
            this.isSnackbar = true;
            this.dialogConfrim = false;
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.dialogConfrim = false;
            reject(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      });
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.setActionsLoader(true);
        if (this.id) {
          Promise.all(this.uploadFilse(this.id))
            .then((urlsData) => {
              urlsData.forEach((url) => {
                if (url.includes("formalFile.")) {
                  this.convenio.formalFile = url;
                  this.convenio.formalFileDate =
                    new Date().toLocaleDateString();
                }
                if (url.includes("informeDetectiveFile.")) {
                  this.convenio.informeDetectiveFile = url;
                  this.convenio.informeDetectiveFileDate =
                    new Date().toLocaleDateString();
                }
              });
              this.update();
            })
            .catch((error) => {
              console.log(`Some failed: `, error.message);
            });
        } else {
          this.userID = await this.save();
          if (this.userID) {
            Promise.all(this.uploadFilse(this.userID))
              .then((urlsData) => {
                urlsData.forEach((url) => {
                  if (url.includes("formalFile.")) {
                    this.convenio.formalFile = url;
                    this.convenio.formalFileDate =
                      new Date().toLocaleDateString();
                  }
                  if (url.includes("informeDetectiveFile.")) {
                    this.convenio.informeDetectiveFile = url;
                    this.convenio.informeDetectiveFileDate =
                      new Date().toLocaleDateString();
                  }
                });
                console.log("before update");
                this.update();
              })
              .catch((error) => {
                console.log(`Some failed: `, error.message);
              });
          }
        }
      }
    },
    getCompanySigla(companyName) {
      return this.getCompany.find((item) => item.name === companyName)?.sigla;
    },
    downloadFile(dataUrl, filename) {
      services.downloadFile(dataUrl, filename);
    },
    async update() {
      let shouldSendResumeEmail = false;
      // NAMING convenio
      let name;
      if (this.convenio.type === "Convenio") name = "CV_";
      else name = "CT_";
      const dateInName = this.convenio.proposalDate.replaceAll("-", "");
      if (dateInName) name += `${dateInName}_`;
      if (this.getCompanySigla(this.convenio.convenioingCompany))
        name += `${this.getCompanySigla(this.convenio.convenioingCompany)}_`;
      if (this.convenio.descOrShortName)
        name += `${this.convenio.descOrShortName}`;
      this.convenio.fileName = name;
      // DEFINE validador
      this.userDG = this.getUsers.find((item) => item.role.includes(1));
      if (!this.convenio.validation.validator) {
        this.convenio.validation.validator = "iwzlJgDtLaeYnxwKp63RhCS5GrZ2"; // this.userDG.id;
      }

      // Change state
      if (this.askForValidation) {
        if (this.isPromotor !== this.isValidator) {
          this.convenio.state = 1;
        } else {
          this.convenio.state = 3;
        }
      } else if (
        this.isValidator &&
        this.convenio.validation.date &&
        this.convenio.validation.validation &&
        !this.convenio.formalFile
      ) {
        this.convenio.state = 2;
      } else if (
        this.isValidator &&
        this.convenio.validation.date &&
        this.convenio.validation.validation === false &&
        !this.convenio.formalFile
      ) {
        this.convenio.state = 0;
      } else if (this.convenio.validation.date && this.convenio.formalFile) {
        this.convenio.state = 4;
      }

      return new Promise((resolve, reject) => {
        services
          .updateData("convenios", {
            id: this.convenio.id || this.convenioID,
            payload: this.convenio,
          })
          .then(() => {
            this.dialogConfrim = false;
            this.setActionsLoader(false);
            resolve(true);
            this.textError = null;
            this.isSnackbar = true;
            if (shouldSendResumeEmail) {
              //this.sendResumen();
            }
            var link = this.id
              ? window.location.href
              : window.location.href +
                `convenios/${this.convenio.id || this.convenioID}`;

            if (this.isPromotor && this.askForValidation) {
              let emailInfo = {
                emailType: "internalEmailBody",
                concept: "convenio",
                to: "dsamper@tram.cat", // dsamper@tram.cat
                from: this.getUserData.email,
                userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
                userWhoRecive: `${this.userDG.name} ${this.userDG.surname}`,
                fileName: this.convenio.fileName,
                link: link,
                validationType: "validar",
                convenioingCompany: this.convenio.convenioingCompany,
                type: this.convenio.type,
                ambito: this.convenio.ambito,
                amount: this.convenio.amount,
              };
              if (this.isPromotor !== this.isValidator) {
                services.sendEmail(emailInfo);
              }
            }
            if (this.convenio.state === 2) {
              let emailInfo2 = {
                emailType: "internalEmailBody",
                concept: "convenio",
                validation: true,
                to: "dsamper@tram.cat", //EQUIP_TRAM@tramvia.onmicrosoft.com
                from: this.getUserData.email,
                userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
                userWhoRecive: `${this.userDG.name} ${this.userDG.surname}`,
                fileName: this.convenio.fileName,
                link: link,
                validationType: "",
                convenioingCompany: this.convenio.convenioingCompany,
                type: this.convenio.type,
                ambito: this.convenio.ambito,
                amount: this.convenio.amount,
                // validationDate: this.frame.validatingPerson.date?.split(",")[0],
                // promoter: `${promoter.name} ${promoter.surname}`,
                // validador: `${validador.name} ${validador.surname}`,
              };
              services.sendEmail(emailInfo2);
            }
            if (this.convenio.state === 0 && this.convenio.validation.date) {
              let emailInfo2 = {
                emailType: "internalEmailBody",
                concept: "convenio",
                validation: false,
                to: "dsamper@tram.cat", //EQUIP_TRAM@tramvia.onmicrosoft.com
                from: this.getUserData.email,
                userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
                userWhoRecive: `${this.userDG.name} ${this.userDG.surname}`,
                fileName: this.convenio.fileName,
                link: link,
                validationType: "",
                convenioingCompany: this.convenio.convenioingCompany,
                type: this.convenio.type,
                ambito: this.convenio.ambito,
                amount: this.convenio.amount,
                reasonDisagreement: this.convenio.validation.description,
                // validationDate: this.frame.validatingPerson.date?.split(",")[0],
                // promoter: `${promoter.name} ${promoter.surname}`,
                // validador: `${validador.name} ${validador.surname}`,
              };
              services.sendEmail(emailInfo2);
            }
            if (this.convenio.state === 4) {
              let emailInfo3 = {
                emailType: "resumenConconvenio",
                to: "dsamper@tram.cat", //EQUIP_TRAM@tramvia.onmicrosoft.com
                from: this.getUserData.email,
                userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
                userWhoRecive: `${this.userDG.name} ${this.userDG.surname}`,
                fileName: this.convenio.fileName,
                link: link,
                validationType: "",
                convenioingCompany: this.convenio.convenioingCompany,
                type: this.convenio.type,
                ambito: this.convenio.ambito,
                amount: this.convenio.amount,
                // validationDate: this.frame.validatingPerson.date?.split(",")[0],
                // promoter: `${promoter.name} ${promoter.surname}`,
                // validador: `${validador.name} ${validador.surname}`,
              };
              services.sendEmail(emailInfo3);
            }
            setTimeout(() => {
              router.go(-1);
            }, 300);
          })
          .catch((e) => {
            this.setActionsLoader(false);
            reject(false);
            console.error(e);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      }).catch((error) => {
        this.setActionsLoader(false);
        console.error(error);
        this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
        this.isSnackbar = true;
      });
    },
    uploadFilse(convenioID) {
      let filesPromises = [];
      if (this.formalFile && this.formalFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "convenios",
            "formalFile." + convenioID + "-" + this.formalFile.name,
            this.formalFile
          )
        );
      }
      if (
        this.informeDetectiveFile &&
        this.informeDetectiveFile.type !== "text/plain"
      ) {
        filesPromises.push(
          services.files.uploadFile(
            "convenios",
            "informeDetectiveFile." +
              convenioID +
              "-" +
              this.informeDetectiveFile.name,
            this.informeDetectiveFile
          )
        );
      }
      return filesPromises;
    },
  },
  watch: {
    // selectedOptions: {
    //   handler() {
    //     // Perform any additional calculations here
    //   },
    //   deep: true,
    // },
    convenio() {
      if (this.convenio.formalFile) {
        this.formalFile = new File(
          [this.convenio.formalFile],
          this.convenio.formalFileName,
          {
            type: "text/plain",
          }
        );
      }
      if (this.convenio.informeDetectiveFile) {
        this.informeDetectiveFile = new File(
          [this.convenio.informeDetectiveFile],
          this.convenio.informeDetectiveFileName,
          {
            type: "text/plain",
          }
        );
      }
      if (this.getUserData && this.convenio.promoter.length === 0) {
        this.convenio.promoter = this.getUserData.id;
      }
    },
    getUserData() {
      this.convenio.promoter =
        this.convenio.promoter.length !== 0
          ? this.convenio.promoter
          : this.getUserData.id;
    },
    getConvenios() {
      if (this.id && this.getConvenios.length !== 0) {
        this.convenio = this.getConvenios.find((item) => item.id === this.id);
      }
    },
    formalFile() {
      this.convenio.formalFileName = this.formalFile.name;
    },
    informeDetectiveFile() {
      this.convenio.informeDetectiveFileName = this.informeDetectiveFile.name;
    },
  },
  mounted() {
    if (this.id && this.getConvenios.length !== 0) {
      this.convenio = this.getConvenios.find((item) => item.id === this.id);
    }
  },
};
</script>
